import React from "react";
import {BasicSearchType} from "../../../../../types/common/basic";
import {useQuery} from "@tanstack/react-query";
import {readAccountBeforePaymentListApi} from "../../../../../api/correspondent/CorresspondentApi";

type Props = {
    searchOption: BasicSearchType & { newLEnduserValue: string };
};

/**
 * 이전결제건 조회 hook
 * @param props
 * @returns
 */
const useReadAccountBeforePaymentList = ({searchOption}: Props) => {
    const {data} = useQuery({
        queryKey: ["readAccountBeforePaymentList", searchOption],
        queryFn: async () => await readAccountBeforePaymentListApi(searchOption),
        select: (res) => res?.result,
        // staleTime: 6000 * 10,
        enabled: searchOption?.newLEnduserValue !== "",
    });
    return {data};
};

export default useReadAccountBeforePaymentList;
